import { parcelsAndOrdersReducer } from "data/actions";
import React, { createContext } from "react";

const initializeParcelsStore: any = {
  orders: {
    successful: [],
    cancelled: [],
    onprogress: [],
  },
  parcels: {
    successful: [],
    cancelled: [],
    onprogress: [],
  },
  task: {
    unassigned: [],
    assigned: [],
    completed: [],
    to_reschedule: [],
  },
};

export const ParcelOrderStoreContext = createContext(initializeParcelsStore);

const ParcelStoreProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = React.useReducer(parcelsAndOrdersReducer, initializeParcelsStore);

  return (
    <ParcelOrderStoreContext.Provider value={[state, dispatch] as any}>{children}</ParcelOrderStoreContext.Provider>
  );
};

export default ParcelStoreProvider;
